import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo2Off: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video-2-off, cam-off, movie, play"><path d="M17.25 17V5.25H8M2.75 7V18.75H12" stroke="currentColor" strokeWidth="1.5"/><path d="M17.25 9L21.75 7V17L17.25 15" stroke="currentColor" strokeWidth="1.5"/><path d="M2.5 2.5L17.5 21.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVideo2Off;
